import { FC } from "react";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import { useNavigate } from "react-router-dom";
import { Skeleton } from "../../../components/loading";

interface VendorBreadcrumbsProps {
  vendorName: string;
  isLoading: boolean;
}

export const VendorBreadcrumbs: FC<VendorBreadcrumbsProps> = (props) => {
  const navigate = useNavigate();

  const handleCatalogClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    navigate("/catalog/product/search");
  };

  return (
    <Breadcrumbs aria-label="breadcrumb">
      <Typography component="span" variant="body1">
        <Link underline="none" href="/search" onClick={handleCatalogClick}>
          Taxonomies & Technologies
        </Link>
      </Typography>
      <Typography>Vendor</Typography>
      <Skeleton isLoading={props.isLoading} width={120} variant="text">
        <Typography>{props.vendorName}</Typography>
      </Skeleton>
    </Breadcrumbs>
  );
};
